import { applyMiddleware, createStore, Reducer } from 'redux'
import { rootReducer } from './reducers'
import { createBrowserHistory } from 'history'
import { createReduxHistoryContext } from 'redux-first-history'
import * as reduxLoop from 'redux-loop'
import { RootState } from './types/types'
import { composeWithDevTools } from 'redux-devtools-extension'
import { Service } from '@src/service'

export function initialState(): RootState {
  return {
    router: undefined,
    user: undefined,
    organization: {},
  }
}

export function newStore(service: Service) {
  const { createReduxHistory, routerMiddleware, routerReducer } = createReduxHistoryContext({
    history: createBrowserHistory(),
  })

  const store = createStore(
    rootReducer(service, routerReducer),
    initialState(),
    composeWithDevTools(applyMiddleware(routerMiddleware), reduxLoop.install())
  )
  const history = createReduxHistory(store)
  return { store, history }
}
